function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardMastercard = function SvgCardMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#780505"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.513 10.661h2.975v4.859h-2.975v-4.859z",
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.82 13.091A3.086 3.086 0 0 1 32 10.662a3.09 3.09 0 1 0 0 4.859 3.083 3.083 0 0 1-1.18-2.43z",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 13.091a3.09 3.09 0 0 1-5 2.429 3.09 3.09 0 0 0 0-4.859 3.09 3.09 0 0 1 5 2.43z",
    style: {
      fill: "#f79e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.293.293 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#400000"
    }
  }));
};
export default SvgCardMastercard;